import { FC } from "react";
import { icMinus, icPlus } from "./image/image-src";
import Icon from "./image/Icon";
import { mergeClass } from "../utils/common";

export const NumPicker: FC<{
  onChange?: (quantity: number) => void;
  disabled?: boolean;
  qty: number;
  minQuantity?: number;
  vari?: "SMALL" | "MED";
}> = ({ onChange, disabled, qty, minQuantity = 0, vari = "MED" }) => {
  const handleDecrease = () => {
    if (disabled) return;
    if (qty > minQuantity) {
      const newQty = qty - 1;
      onChange?.(newQty);
    }
  };

  const handleIncrease = () => {
    if (disabled) return;
    const newQty = qty + 1;
    onChange?.(newQty);
  };

  const btnClassName = mergeClass(
    "disabled:cursor-not-allowed flex justify-center items-center rounded-full",
    vari === "SMALL" ? "size-[1.5rem]" : "size-7 sm:size-[2.125rem]",
  );
  return (
    <div className="flex items-center">
      <button
        onClick={handleDecrease}
        className={btnClassName}
        disabled={qty <= minQuantity || disabled}
      >
        <Icon src={icMinus} />
      </button>
      <p className="min-w-[2.1875rem] text-center text-sm font-normal text-[#232323] sm:text-base sm:leading-[1.25rem]">
        {qty}
      </p>

      <button
        onClick={handleIncrease}
        className={btnClassName}
        disabled={disabled}
      >
        <Icon src={icPlus} />
      </button>
    </div>
  );
};
